// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7506d987b5--container--D0KwZ","title_and_description":"_7506d987b5--title_and_description--bi3Au"};